/* istanbul ignore file */
import { number as codecNumber, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const BaseUserParser = /* #__PURE__ */ parsers.object([
    ['id', codecNumber],
    ['username', codecString],
    ['tenantId', /* #__PURE__ */ parsers.maybeNull(codecString), 'tenant_id'],
]);
export class BaseUser extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return BaseUserParser.decode(input).map(res => new BaseUser(res));
    }
    static unsafeDecode(input) {
        return BaseUser.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return BaseUserParser.encode(data);
    }
    static schema() {
        return BaseUserParser.schema();
    }
}
